import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Stack, Typography } from '@mui/material'
import { routesProfile } from '../../../consts'
import { getSafeReturnPath } from '../../../utils/getSafeReturnPath'
import { AuthForm } from '../AuthForm'
import { PasswordAuthForm } from '../PasswordAuthForm'
import { H1Welcome } from './style'

type FormType = 'otp' | 'password_auth' | 'reg' | 'restore'

export const GuestAuthIntercept = () => {
  const location = useLocation()
  const returnPath = `${location.pathname}${location.search}`
  const returnTo = getSafeReturnPath(returnPath, routesProfile.ROOT.path)

  const [formType, setFormType] = useState<FormType>('otp')

  const renderForm = () => {
    switch (formType) {
      case 'otp':
        return <AuthForm onSwitch={setFormType} returnTo={returnTo} />
      case 'password_auth':
        return <PasswordAuthForm onSwitch={setFormType} returnTo={returnTo} />
      default:
        return null
    }
  }

  return (
    <Stack 
      alignItems="center" 
      textAlign='center' 
      justifyContent="center" 
      width="100%" 
      maxWidth="100%" 
      alignSelf="center" 
      pb={4} 
      px={2}
    >
      <Typography variant="h1" sx={H1Welcome}>Авторизуйтесь для дальнейшего пользования</Typography>
      <Box maxWidth="360px" mt={5}>
        {renderForm()}
      </Box>
    </Stack>
  )
}
